import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import Modal from "@material-ui/core/Modal";
import { FaCheckCircle, FaTimes, FaCalendarAlt } from "react-icons/fa";
import "./Operation.css";

function toDatetimeLocalValue(date) {
  const d = new Date(date);
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

function toLocalISOString(dateStr) {
  const date = new Date(dateStr);
  const tzOffset = -date.getTimezoneOffset();
  const sign = tzOffset >= 0 ? "+" : "-";
  const hours = String(Math.floor(Math.abs(tzOffset) / 60)).padStart(2, "0");
  const minutes = String(Math.abs(tzOffset) % 60).padStart(2, "0");
  const pad = (n) => String(n).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}${sign}${hours}:${minutes}`;
}

function ConfirmApplicationModal({ show, onHide, onConfirm, t }) {
  const [applicationDate, setApplicationDate] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (show) {
      setApplicationDate(toDatetimeLocalValue(new Date()));
      setSubmitting(false);
    }
  }, [show]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!applicationDate) return;
    setSubmitting(true);
    try {
      await onConfirm(toLocalISOString(applicationDate));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal open={!!show} onClose={onHide}>
      <div className="modal-size" style={{ maxWidth: "420px" }}>
        <div className="x_title">
          <h5 align="center">
            <FaCheckCircle style={{ marginRight: "6px" }} />
            {t("Confirmar Aplicação")}
          </h5>
          <div className="clearfix"></div>
        </div>
        <form onSubmit={handleSubmit} style={{ padding: "10px" }}>
          <div className="form-group">
            <label>
              <FaCalendarAlt style={{ marginRight: "5px" }} />
              {t("Data em que a aplicação foi efetuada")}
            </label>
            <input
              type="datetime-local"
              className="form-control"
              value={applicationDate}
              onChange={(e) => setApplicationDate(e.target.value)}
              required
              autoFocus
            />
          </div>
          <div className="text-right" style={{ marginTop: "15px" }}>
            <button
              type="button"
              className="btn btn-default"
              onClick={onHide}
              disabled={submitting}
              style={{ marginRight: "8px" }}
            >
              <FaTimes style={{ marginRight: "5px" }} />
              {t("Cancelar")}
            </button>
            <button
              type="submit"
              className="btn btn-success"
              disabled={submitting || !applicationDate}
            >
              <FaCheckCircle style={{ marginRight: "5px" }} />
              {submitting ? t("Confirmando...") : t("Confirmar")}
            </button>
          </div>
        </form>
      </div>
    </Modal>
  );
}

export default withTranslation()(ConfirmApplicationModal);
